module.exports = __webpack_public_path__ + "static/media/39_B.30837d16.png";